import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProgressArc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconProgressArc"><Path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 12L18.7549 16.2861C19.5224 15.0766 19.9511 13.6828 19.9961 12.251C20.041 10.8191 19.7009 9.40091 19.0107 8.14551C18.3205 6.89013 17.3054 5.84352 16.0723 5.11426C14.8391 4.38495 13.4327 4 12 4V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProgressArc;
